import { Expose, Type } from "class-transformer";
import type { UUID } from "node:crypto";
import { ProfileCompletion } from "../../features/profile/types/profile-completion/profile-completion.entity";
import type { IProfileCompletion } from "../../features/profile/types/profile-completion/profile-completion.entity.interface";
import { Activity } from "../../legacy/services/activity/entities/activity/activity.entity";
import { HouseholdMemberWithAllData } from "../../features/profile/types/household-member-with-all-data/household-member-with-all-data.entity";
import type { IHouseholdMemberWithAllData } from "../../features/profile/types/household-member-with-all-data/household-member-with-all-data.entity.interface";
import { RealEstate } from "../../features/profile/types/real-estate/real-estate.entity";
import type { IProfile } from "./profile.entity.interface";

export class Profile implements IProfile {
  @Expose()
  personaId!: UUID;

  @Expose()
  firstName!: string;

  @Expose()
  lastName!: string;

  @Expose()
  taxCode!: string;

  @Expose()
  birthDate!: string;

  @Expose()
  citizenship!: string[];

  @Expose()
  isHouseholdCompositionAsked!: boolean;

  @Expose()
  isHouseholdConfirmed?: boolean;

  @Expose()
  hasKnownIsee?: boolean;

  @Expose()
  hasDeclaredIncome?: boolean;

  @Expose()
  isIncomeConfirmed?: boolean;

  @Expose()
  isRealEstateConfirmed?: boolean;

  @Expose()
  @Type(() => Activity)
  activities!: Activity[];

  @Expose()
  @Type(() => HouseholdMemberWithAllData)
  householdMembers!: IHouseholdMemberWithAllData[];

  @Expose()
  lastUpdatedDate?: string;

  @Expose()
  accountId!: number;

  @Expose()
  pictureUrl?: string;

  @Expose()
  citizenId!: number;

  @Expose()
  migrationStartedAt?: string;

  @Expose()
  migrationCompletedAt?: string;

  @Expose()
  @Type(() => RealEstate)
  realEstates!: RealEstate[];

  @Expose()
  @Type(() => ProfileCompletion)
  completion!: IProfileCompletion;
}
